import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withUserType } from '../withUserType';
import { Checkbox, Col, Collapse, Row, Tag, Tooltip, Button } from 'antd';
import { capitalizeEachWord } from '../../utils/DataFormatterUtils';
import { lengthTruncatedText } from '../../utils/TextFormatterUtils';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';

function transformCategoryData(input) {
	return Object.entries(input)
		.filter(([key]) => key.trim() !== '')
		.map(([categoryName, count]) => ({
			categoryName,
			count,
		}));
}

const WrenchHubCategoryFilters = ({ suppliersStateSlice, updateFilters }) => {
	const [showAll, setShowAll] = useState(false);

	const allData = transformCategoryData(nullSafeGetOrElse('counts', suppliersStateSlice, {}));
	const handleCheckboxChange = (checkedValues) => {
		updateFilters({ categoryNames: checkedValues.length ? checkedValues.join(',') : undefined });
	};

	const toggleShowAll = () => {
		setShowAll(!showAll);
	};

	const displayedData = showAll ? allData : allData.slice(0, 10);

	const selectedCategoryNames = nullSafeGetOrElse('filters.categoryNames', suppliersStateSlice, '');
	const selectedCategoryNamesList = selectedCategoryNames
		? String(selectedCategoryNames)
				.split(',')
				.filter((categoryName) => categoryName.length > 0)
		: [];

	return (
		<Row style={{ margin: '0.5em 0' }}>
			<Col span={24}>
				<div>
					<Collapse defaultActiveKey={['1']}>
						<Collapse.Panel header="Services Provided" key="1">
							<div style={{ padding: '0 8px' }}>
								<div style={{ marginBottom: 8 }}>
									<Checkbox.Group value={selectedCategoryNamesList} onChange={handleCheckboxChange}>
										{displayedData.map((category, idx) => (
											<Row key={category.categoryName}>
												<Checkbox
													style={{
														lineHeight: '40px',
														fontSize: 14,
														marginLeft: 0,
													}}
													value={category.categoryName}
												>
													<Tooltip title={capitalizeEachWord(category.categoryName)}>
														{lengthTruncatedText(capitalizeEachWord(category.categoryName), 35)}
														<Tag style={{ marginLeft: 8 }}>{category.count}</Tag>
													</Tooltip>
												</Checkbox>
											</Row>
										))}
									</Checkbox.Group>
								</div>
								{allData.length > 10 && (
									<Button type="link" onClick={toggleShowAll}>
										{showAll ? 'Show Less' : 'Show All'}
									</Button>
								)}
							</div>
						</Collapse.Panel>
					</Collapse>
				</div>
			</Col>
		</Row>
	);
};

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch, ownProps) => ({});

export default withUserType(connect(mapStateToProps, mapDispatchToProps)(WrenchHubCategoryFilters));
